import { Button } from 'antd';
import PropTypes from 'prop-types';

export function ExpandIcon({ onExpand, record }) {
  return (
    <Button className="dots-expand" onClick={() => onExpand(record)}>
      &bull; &bull; &bull;
    </Button>
  );
}

ExpandIcon.propTypes = {
  onExpand: PropTypes.func.isRequired,
  record: PropTypes.shape().isRequired
};
